import { useState } from "react";
import API from "../../services/api";

function InterventionPanel({
  cardStyle,
  emptyBoxStyle,
  inputStyle,
  sectionTitleStyle,
  primaryButtonStyle,
  interventi,
  mostraNuovoIntervento,
  nuovoIntervento,
  setMostraNuovoIntervento,
  setNuovoIntervento,
  salvaNuovoIntervento,
  salvaFirmaIntervento,
  modificaIntervento,
  formatDate,
  renderActions,
}) {
  const [firmaApertaId, setFirmaApertaId] = useState(null);
  const [firmaCliente, setFirmaCliente] = useState("");

  const [interventoInModificaId, setInterventoInModificaId] = useState(null);

const [interventoModificato, setInterventoModificato] = useState({
  intervention_date: "",
  intervention_type: "",
  status: "Programmato",
  technician_name: "",
  outcome: "",
  notes: "",
  customer_signature: "",
  completion_date: "",
});

  const utenteCorrente = JSON.parse(
    localStorage.getItem("utenteCorrente")
  );

  const labelStyle = {
    fontSize: "13px",
    fontWeight: 700,
    marginBottom: "6px",
    color: "#475569",
  };

  const helpTextStyle = {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "5px",
    lineHeight: "1.4",
  };

  const fieldWrapperStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const firmaBoxStyle = {
    marginTop: "12px",
    padding: "12px",
    borderRadius: "10px",
    border: "1px dashed #94a3b8",
    background: "#f8fafc",
  };

  const handleModificaIntervento = (id) => {
  if (typeof modificaIntervento !== "function") {
    alert("Funzione modifica intervento non disponibile.");
    return;
  }

  modificaIntervento(id, interventoModificato);
  setInterventoInModificaId(null);
};

  return (
    <div style={cardStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "14px",
        }}
      >
        <h2 style={sectionTitleStyle}>
  Storico interventi ({interventi.length})
</h2>

        {utenteCorrente?.role !== "viewer" && (
          <button
            className="btn btn-primary"
            onClick={() => setMostraNuovoIntervento(true)}
            style={primaryButtonStyle}
          >
            + Intervento
          </button>
        )}
      </div>

      {mostraNuovoIntervento && (
        <div
          style={{
            ...emptyBoxStyle,
            marginBottom: "18px",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
          }}
        >
          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Tipo di intervento</div>
            <input
              placeholder="Esempio: Manutenzione ordinaria, riparazione, sopralluogo"
              value={nuovoIntervento.intervention_type}
              onChange={(e) =>
                setNuovoIntervento({
                  ...nuovoIntervento,
                  intervention_type: e.target.value,
                })
              }
              style={inputStyle}
            />
            <div style={helpTextStyle}>
              Indica in modo chiaro che tipo di attività è stata eseguita.
            </div>
          </div>

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Tecnico incaricato</div>
            <input
              placeholder="Nome del tecnico o della squadra intervenuta"
              value={nuovoIntervento.technician_name}
              onChange={(e) =>
                setNuovoIntervento({
                  ...nuovoIntervento,
                  technician_name: e.target.value,
                })
              }
              style={inputStyle}
            />
            <div style={helpTextStyle}>
              Inserisci chi ha eseguito l’intervento.
            </div>
          </div>

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Esito dell’intervento</div>
            <textarea
              placeholder="Esempio: intervento completato con esito positivo, problema risolto, verifica effettuata"
              value={nuovoIntervento.outcome}
              onChange={(e) =>
                setNuovoIntervento({
                  ...nuovoIntervento,
                  outcome: e.target.value,
                })
              }
              rows={3}
              style={{ ...inputStyle, resize: "vertical" }}
            />
            <div style={helpTextStyle}>
              Riassumi il risultato finale dell’intervento.
            </div>
          </div>

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Note tecniche</div>
            <textarea
              placeholder="Esempio: componenti controllati, anomalie rilevate, ricambi utilizzati, indicazioni future"
              value={nuovoIntervento.notes}
              onChange={(e) =>
                setNuovoIntervento({
                  ...nuovoIntervento,
                  notes: e.target.value,
                })
              }
              rows={3}
              style={{ ...inputStyle, resize: "vertical" }}
            />
            <div style={helpTextStyle}>
              Aggiungi dettagli utili per lo storico tecnico dell’impianto.
            </div>
          </div>

          {renderActions(
            salvaNuovoIntervento,
            () => setMostraNuovoIntervento(false),
            "Salva intervento"
          )}
        </div>
      )}

      {interventi.length === 0 ? (
        <div style={emptyBoxStyle}>Nessun intervento registrato.</div>
      ) : (
  <div
    style={{
      maxHeight: interventi.length > 2 ? "650px" : "none",
      overflowY: interventi.length > 2 ? "auto" : "visible",
      paddingRight: interventi.length > 2 ? "6px" : 0,
    }}
  >
    {interventi.map((item) => {
          const hasSignature = Boolean(item.customer_signature);

          return (
            <div
              key={item.id}
              style={{
                ...emptyBoxStyle,
                marginBottom: "12px",
              }}
            >
              <strong>{item.intervention_type || "Intervento tecnico"}</strong>

              <div>
                <strong>Data intervento:</strong>{" "}
                {formatDate(item.intervention_date)}
              </div>

              <div>
                <strong>Tecnico:</strong> {item.technician_name || "—"}
              </div>

              <div>
                <strong>Stato:</strong> {item.status || "—"}
              </div>

              <div>
                <strong>Esito:</strong> {item.outcome || "—"}
              </div>

              <div>
                <strong>Note tecniche:</strong> {item.notes || "—"}
              </div>

            {utenteCorrente?.role !== "viewer" && (
  <div
    style={{
      display: "flex",
      gap: "10px",
      marginTop: "12px",
      flexWrap: "wrap",
    }}
  >
    <button
      onClick={() => {
        setInterventoInModificaId(item.id);
        setInterventoModificato({
          intervention_date: item.intervention_date || "",
          intervention_type: item.intervention_type || "",
          status: item.status || "Programmato",
          technician_name: item.technician_name || "",
          outcome: item.outcome || "",
          notes: item.notes || "",
          customer_signature: item.customer_signature || "",
          completion_date: item.completion_date || "",
        });
      }}
      style={{
        background: "#e0f2fe",
        color: "#075985",
        border: "none",
        borderRadius: "10px",
        padding: "10px 16px",
        cursor: "pointer",
        fontWeight: 700,
        fontSize: "14px",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "#bae6fd";
        e.currentTarget.style.transform = "translateY(-1px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "#e0f2fe";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      ✏️ Modifica
    </button>
  </div>
)}

              <div style={{ marginTop: "10px" }}>
                <strong>Firma cliente:</strong>{" "}
                {hasSignature ? (
                  <span
                    style={{
                      color: "#166534",
                      fontWeight: 700,
                    }}
                  >
                    ✓ Firmato
                  </span>
                ) : (
                  <span style={{ color: "#92400e", fontWeight: 700 }}>
                    Non firmato
                  </span>
                )}
              </div>

              {hasSignature && (
  <>
    <div
      style={{
        marginTop: "12px",
        padding: "18px",
        borderRadius: "12px",
        background: "#ffffff",
        border: "1px solid #dbe4f0",
        textAlign: "center",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          color: "#64748b",
          fontWeight: 700,
          marginBottom: "10px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        Firma acquisita
      </div>

      <div
        style={{
          fontFamily: "'Segoe Script', cursive",
          fontSize: "34px",
          fontWeight: "600",
          color: "#173a63",
          lineHeight: "1.3",
        }}
      >
        {item.customer_signature}
      </div>
    </div>

    <div
      style={{
        marginTop: "18px",
        borderTop: "1px solid #dbe4f0",
        paddingTop: "16px",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#94a3b8",
          marginBottom: "12px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        Documentazione
      </div>

      <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  }}
>
  <button
    onClick={async () => {
      try {
        const response = await fetch(
          `${API}/interventions/${item.id}/pdf`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Errore apertura verbale");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (err) {
        console.error(err);
        alert("Errore durante l'apertura del verbale.");
      }
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-1px)";
      e.currentTarget.style.boxShadow =
        "0 4px 12px rgba(23,58,99,0.25)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}
    style={{
      ...primaryButtonStyle,
      width: "100%",
      padding: "14px 18px",
      fontSize: "15px",
      fontWeight: 700,
      lineHeight: "1.2",
      transition: "all 0.2s ease",
    }}
  >
    📄 Apri verbale
  </button>

  <button
    onClick={async () => {
      try {
        const response = await fetch(
          `${API}/interventions/${item.id}/send-pdf`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || "Errore invio verbale");
        }

        alert("Verbale dell'intervento inviato correttamente al cliente.");
      } catch (err) {
        console.error(err);
        alert(err.message || "Errore durante l'invio del verbale.");
      }
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "#166534";
      e.currentTarget.style.transform = "translateY(-1px)";
      e.currentTarget.style.boxShadow =
        "0 4px 12px rgba(22,101,52,0.25)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "#15803d";
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}
    style={{
      background: "#15803d",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      padding: "14px 18px",
      cursor: "pointer",
      fontWeight: 700,
      fontSize: "15px",
      lineHeight: "1.2",
      width: "100%",
      transition: "all 0.2s ease",
    }}
  >
    📧 Invia verbale dell'intervento
  </button>

  {utenteCorrente?.role === "admin" && (
    <button
      onClick={async () => {
        const conferma = window.confirm(
          "Vuoi eliminare questo intervento?"
        );

        if (!conferma) return;

        try {
          const response = await fetch(
            `${API}/interventions/${item.id}`,
            {
              method: "DELETE",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Errore eliminazione intervento");
          }

          alert("Intervento eliminato correttamente.");
          window.location.reload();
        } catch (err) {
          console.error(err);
          alert("Errore durante l'eliminazione dell'intervento.");
        }
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "#b91c1c";
        e.currentTarget.style.transform = "translateY(-1px)";
        e.currentTarget.style.boxShadow =
          "0 4px 12px rgba(185,28,28,0.25)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "#dc2626";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
      style={{
        background: "#dc2626",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        padding: "14px 18px",
        cursor: "pointer",
        fontWeight: 700,
        fontSize: "15px",
        lineHeight: "1.2",
        width: "100%",
        transition: "all 0.2s ease",
      }}
    >
      🗑 Elimina intervento
    </button>
  )}
</div>
    </div>
  </>
)}

{interventoInModificaId === item.id && (
  <div
    style={{
      marginTop: "16px",
      padding: "16px",
      borderRadius: "12px",
      background: "#f8fafc",
      border: "1px solid #dbeafe",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    }}
  >
    <input
      value={interventoModificato.intervention_type}
      onChange={(e) =>
        setInterventoModificato({
          ...interventoModificato,
          intervention_type: e.target.value,
        })
      }
      placeholder="Tipo intervento"
      style={inputStyle}
    />

    <input
      type="datetime-local"
      value={
        interventoModificato.intervention_date
          ? interventoModificato.intervention_date.slice(0, 16)
          : ""
      }
      onChange={(e) =>
        setInterventoModificato({
          ...interventoModificato,
          intervention_date: e.target.value,
        })
      }
      style={inputStyle}
    />

    <input
      value={interventoModificato.technician_name}
      onChange={(e) =>
        setInterventoModificato({
          ...interventoModificato,
          technician_name: e.target.value,
        })
      }
      placeholder="Tecnico"
      style={inputStyle}
    />

    <select
  value={interventoModificato.status}
  onChange={(e) =>
    setInterventoModificato({
      ...interventoModificato,
      status: e.target.value,
    })
  }
  style={inputStyle}
>
  <option value="Programmato">Programmato</option>
  <option value="Completato">Completato</option>
  <option value="Annullato">Annullato</option>
</select>

    <textarea
      value={interventoModificato.outcome}
      onChange={(e) =>
        setInterventoModificato({
          ...interventoModificato,
          outcome: e.target.value,
        })
      }
      rows={3}
      placeholder="Esito"
      style={{
        ...inputStyle,
        resize: "vertical",
      }}
    />

    <textarea
      value={interventoModificato.notes}
      onChange={(e) =>
        setInterventoModificato({
          ...interventoModificato,
          notes: e.target.value,
        })
      }
      rows={3}
      placeholder="Note tecniche"
      style={{
        ...inputStyle,
        resize: "vertical",
      }}
    />

    <div
      style={{
        display: "flex",
        gap: "10px",
      }}
    >
      <button
        onClick={() => handleModificaIntervento(item.id)}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow =
            "0 4px 12px rgba(23,58,99,0.25)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
        style={{
          ...primaryButtonStyle,
          transition: "all 0.2s ease",
        }}
      >
        Salva modifiche
      </button>

      <button
        onClick={() => setInterventoInModificaId(null)}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#cbd5e1";
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow =
            "0 4px 10px rgba(71,85,105,0.18)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#e2e8f0";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
        style={{
          background: "#e2e8f0",
          border: "none",
          borderRadius: "8px",
          padding: "10px 14px",
          cursor: "pointer",
          fontWeight: 600,
          transition: "all 0.2s ease",
        }}
      >
        Annulla
      </button>
    </div>
  </div>
)}

              {!hasSignature && utenteCorrente?.role !== "viewer" && (
                <div style={{ marginTop: "10px" }}>
                  {firmaApertaId !== item.id ? (
                    <button
                      onClick={() => {
                        setFirmaApertaId(item.id);
                        setFirmaCliente("");
                      }}
                      style={primaryButtonStyle}
                    >
                      Firma cliente
                    </button>
                  ) : (
                    <div style={firmaBoxStyle}>
                      <div style={labelStyle}>Firma cliente</div>

                      <input
                        placeholder="Scrivi nome e cognome del cliente"
                        value={firmaCliente}
                        onChange={(e) => setFirmaCliente(e.target.value)}
                        style={{
                          ...inputStyle,
                          fontFamily: "cursive",
                          fontSize: "22px",
                        }}
                      />

                      <div style={helpTextStyle}>
                        Versione semplice e sicura: la firma viene salvata come
                        testo. In seguito potremo sostituirla con firma grafica
                        su tablet.
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          marginTop: "12px",
                        }}
                      >
                        <button
                          onClick={async () => {
                            await salvaFirmaIntervento(item.id, firmaCliente);
                            setFirmaApertaId(null);
                            setFirmaCliente("");
                          }}
                          style={primaryButtonStyle}
                        >
                          Salva firma
                        </button>

                        <button
                          onClick={() => {
                            setFirmaApertaId(null);
                            setFirmaCliente("");
                          }}
                          style={{
                            background: "#e2e8f0",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 14px",
                            cursor: "pointer",
                            fontWeight: 600,
                          }}
                        >
                          Annulla
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
  </div>
)}
    </div>
  );
}

export default InterventionPanel;